var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rodemap"},[_c('WordDialog',{key:_vm.index,attrs:{"data":_vm.arr[_vm.index]},on:{"jump":_vm.jump}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }